import { Params } from '@angular/router';

// console output is forwarded to Bugfender, so credentials and personal data must never be logged in plain text
const sensitiveParamNames = ['token', 'id_token', 'access_token', 'refresh_token', 'jwt', 'email', 'login_hint'];
const sensitiveParamPattern = new RegExp(`([?&#](?:${sensitiveParamNames.join('|')})=)[^&#]*`, 'gi');

export const redacted = '[REDACTED]';

export function redactUrl(url: string | undefined): string | undefined {
  return url?.replace(sensitiveParamPattern, `$1${redacted}`);
}

export function redactParams(params: Params): Params {
  return Object.fromEntries(
    Object.entries(params ?? {}).map(([key, value]) => [
      key,
      sensitiveParamNames.includes(key.toLowerCase()) ? redacted : value,
    ])
  );
}
